import { UiTypography } from '@/components/ui/Typography';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import { PaymentDescriptionTermsAndLinks } from './Description';

export function WeeklyRebillDescription({
  selectedPlan,
  monthlyPlan,
}: {
  selectedPlan: StripeV2SubscriptionPrice;
  monthlyPlan: StripeV2SubscriptionPrice;
}) {
  return (
    <UiTypography
      variant="body-small"
      color="neutral-black"
      align="center"
      className="local-description"
    >
      You will be automatically charged ${selectedPlan.price} after the payment
      confirmation. The subscription will then be auto-renewed monthly after a
      1-week intro offer at the full price of ${monthlyPlan.original_price}.
      Payments are charged in USD, excluding taxes.{' '}
      <PaymentDescriptionTermsAndLinks />
    </UiTypography>
  );
}
